module.exports = __webpack_public_path__ + "static/img/cgal12.3420ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal12.png
// module id = y/je
// module chunks = 1